
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";
import { IconListItem } from "@/components/ui/icon-list-item";

interface AmenitiesSectionProps {
  amenities: string[];
}

export function AmenitiesSection({ amenities }: AmenitiesSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Amenities</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {amenities?.map((amenity) => (
            <IconListItem key={amenity} icon={Star} text={amenity} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
